import { createV3Queries } from "@query/utils/createV3Queries";
import { workLogsApi } from "@api";

export const queriesWorkLogs = createV3Queries("workLogsApi", workLogsApi);
